import type { SVGProps } from 'react';

export function KnightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m8.592.997-.172.032-.134.033a1.2 1.2 0 0 0-.403.216 1.1 1.1 0 0 0-.286.35 1.1 1.1 0 0 0-.067.872l.876 2.542-3.293 1.964a2.27 2.27 0 0 0-1.05 1.404c-.143.584-.041 1.2.284 1.711l.104.15c.217.288.501.522.83.683.327.161.69.245 1.058.245h1.829L6.279 16.49a1.1 1.1 0 0 0 .153 1.027c.108.148.251.267.417.35s.35.126.536.126h9.314c.306 0 .6-.116.818-.323.219-.207.345-.489.352-.784l.13-5.662c0-4.333-1.818-7.788-5.463-9.02l-2.806-.94-.44-.136-.301-.084-.158-.035-.118-.015-.064-.001zM18.857 18.993H5.143a1.23 1.23 0 0 0-.808.293.94.94 0 0 0-.335.707c0 .53.24 1.04.67 1.414.428.375 1.01.586 1.616.586h11.428c.56 0 1.102-.18 1.52-.506.42-.326.686-.775.751-1.262l.013-.174a.9.9 0 0 0-.067-.4 1 1 0 0 0-.243-.344 1.2 1.2 0 0 0-.378-.232 1.3 1.3 0 0 0-.453-.082" />
    </svg>
  );
}
